import React, { useState, useEffect } from 'react';
import { Create } from "@mui/icons-material";
import { Button, IconButton, TextField } from "@mui/material";
import Header from "../layouts/Header";
import { instance } from "../utils/api";
import { useParams } from "react-router-dom";


const cl = "app-page-profile";

function Profile() {
    const [profileData, setprofileData] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [image, setImage] = useState(null);
    const ID = localStorage.getItem("ID");
    const [newImage, setNewImage] = useState(null);
    useEffect(() => {
        if (ID) {

            async function fetchProfileData() {
                try {
                    const response = await instance.get(`agents/${ID}`);
                    setprofileData(response.data);
                    const updateData = response.data
                    setName(updateData.name);
                    setPhone(updateData.phone);
                    setImage(updateData.image)
                    console.log(updateData)
                } catch (error) {
                    console.error('Error fetching profile data:', error);
                }
            }

            fetchProfileData();
        }
    }, [ID]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        console.log('Selected file:', file);
        setNewImage(file);  
        handleUpdateProfile();
    };


    const handleUpdateProfile = async () => {
        const formData = new FormData();
        formData.append("name", name);
        formData.append("phone", phone);
        if (newImage) {
            formData.append("image", newImage);
        }
        try {
            const response = await instance.patch("agents/update", formData);
            console.log('Profile Updated:', response.data);
            console.log(response.data.image)
            setprofileData(response.data); 
          
        } catch (error) {
            console.error('Error updating profile:', error);
        }
    };

    return (
        <>
            <div className="profile-page">
                <Header />
            </div>
            <div className={`${cl}`}>
                <div className={`${cl}__wrapper`}>
                    <div className={`${cl}__card`}>
                        <div className={`${cl}__image`}>
                            <input
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                id="image-upload"
                                onChange={handleImageChange}
                            />
                            <label htmlFor="image-upload" style={{ cursor: "pointer" }}>
                                <img
                                    src={newImage ? URL.createObjectURL(newImage) : (profileData.image || '')}
                                    alt="Profile"
                                />
                            </label>
                            <IconButton
                                size="small"
                                style={{ position: "absolute" }}
                                onClick={() => {
                                    document.getElementById("image-upload").click();
                                }}
                                onChange={handleImageChange}
                            >
                                <Create />
                            </IconButton>

                        </div>




                        <div className={`${cl}__info`}>
                            <ul className={`${cl}__infolist`}>
                                <li className={`${cl}__infolistitem`}>
                                    <h6>Email</h6>
                                    <p>{profileData.email}</p>
                                </li>
                                <li className={`${cl}__infolistitem`}>
                                    <TextField value={name} onChange={(e) => setName(e.target.value)} id="standard-basic" label="Name" variant="standard" />
                                </li>
                                <li className={`${cl}__infolistitem`}>
                                    <TextField value={phone} onChange={(e) => setPhone(e.target.value)} id="standard-basic" label="Phone" variant="standard" />
                                </li>
                                <li className={`${cl}__infolistitem --button`}>
                                    <Button onClick={handleUpdateProfile} variant="contained">Update Profile</Button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Profile;

